'use client'

import { useTranslation } from '@/hooks/client/use-translation'
import { formatOfferPrice as formatPrice } from '@/lib/prices/format-offer-price'

import { effectiveSellerPrice, type PriceSellerData } from './price-section-types'
import { isMonthlyPriceType } from './price-step'

/** The seller row's price block: struck list price and savings chip when discounted, the price, the unit. */
export const SellerPrice = ({ seller }: { seller: PriceSellerData }) => {
  const { t } = useTranslation()
  const hasPrice = seller.price > 0
  const effective = effectiveSellerPrice(seller)
  const hasDiscount = hasPrice && effective < seller.price

  if (!hasPrice) {
    return (
      <div className="text-navy text-[15px] font-semibold sm:text-right">
        {t('price.callForPrice', 'Call for price')}
      </div>
    )
  }

  return (
    <div className="tabular-nums sm:text-right">
      {hasDiscount && (
        <div className="flex items-center gap-1.5 sm:justify-end">
          <span className="text-[12px] text-slate-400 line-through">{formatPrice(seller.price)}</span>
          <span className="rounded-md bg-[#ecfdf5] px-1.5 py-0.5 text-[11px] font-bold text-[#047857]">
            -{formatPrice(seller.price - effective)}
          </span>
        </div>
      )}
      <div className="text-navy text-[22px] leading-tight font-extrabold">{formatPrice(effective)}</div>
      <div className="text-navy-60 text-[12px]">
        {isMonthlyPriceType(seller.priceType)
          ? t('price.perPairMonthlyPhrase', 'per pair, per month')
          : t('price.perPairPhrase', 'per pair')}
      </div>
    </div>
  )
}
